/**   
 * 门店管理
 */
export default {
  /**
   * 门店管理
   */
  selectStoreInfoList: "/storeInfo/selectStoreInfoList", //门店列表
  selectStoreInfo: "/storeInfo/selectStoreInfoDetail", //门店详情
  addStoreList: "/storeInfo/insertStoreInfo", //添加门店
  editStoreList: "/storeInfo/updateStoreInfo", //修改门店
  deleteStoreList: "/storeInfo/deleteStoreInfo", //删除门店
  storeAddAddress: "/districtInfo/getDistrictInfo", //门店省市区
};